import { useEffect } from 'react'
import { useFormikContext } from 'formik'

import { TASK_FORM_PHASE_FIELD_NAME } from '../../../TaskForm.constants'

export function usePhaseFieldSuccessLoad(items) {
  const { setFieldValue } = useFormikContext()

  useEffect(() => {
    if (items?.length === 1) {
      setFieldValue(TASK_FORM_PHASE_FIELD_NAME, items[0].id)
    }
  }, [items])
}
